export default {
  saveUserInfo (state, { accid, icon, name, token }) {
    state.accid = accid
    state.icon = icon
    state.name = name
    state.token = token
  },
  setRole (state, { role }) {
    state.role = role
  },
  updateOnlineMemberNum (state, { onlineMemberNum }) {
    state.onlineMemberNum = onlineMemberNum
  },
  updateBroadcast (state, { courseId, content }) {
    state.broadcast = { courseId, content }
  },
  setMessageTips (state, { content }) {
    state.messageTips = content
  },
}
